import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
/**
 * __Close button__
 *
 * The close button is to be used for customized modal headers to ensure that
 * all users have an accessible and obvious way to close the modal dialog.
 */
export var CloseButton = function CloseButton(_ref) {
  var label = _ref.label,
    onClick = _ref.onClick,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(IconButton, {
    testId: testId && "".concat(testId, "--close-button"),
    appearance: "subtle",
    icon: CrossIcon,
    label: label || 'Close Modal',
    onClick: onClick
  });
};